import React from 'react';
import { ClipboardCheckIcon, KeyRoundIcon, MapIcon, MessagesSquareIcon, NotebookPenIcon, PresentationIcon } from 'lucide-react';
import { toolkitItems, volumeColors, volumes } from '../data/content';
import { Highlight } from './Highlight';
const toolkitIcons = [NotebookPenIcon, MapIcon, MessagesSquareIcon, PresentationIcon, ClipboardCheckIcon, KeyRoundIcon];
export function WhatsInside() {
  return <section id="inside" className="w-full bg-paper px-5 py-20 sm:py-28" data-id="element-251" data-mp="b66dsitoymbp">
      <div className="mx-auto max-w-6xl" data-id="element-252" data-mp="fx4wtq62dyin">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-5xl" data-id="element-253" data-mp="fxy6p00bl450">
          What&apos;s Inside the <Highlight data-id="element-254" data-mp="74l2v30pwi45">CAREER READY™</Highlight> Pack?
        </h2>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-255" data-mp="72qk9vcx5238">
          {volumes.map((volume, index) => {
          const color = volumeColors[index];
          return <li key={volume.number} className="flex flex-col overflow-hidden rounded-2xl border-2 border-ink bg-white shadow-pop" data-id="element-256" data-mp="3taq5n04ycy4f" data-mpi={index}>
                <div className={`flex min-h-[8.5rem] items-end gap-4 border-b-2 border-ink px-6 py-5 ${color.bg} ${color.fg}`} data-id="element-257" data-mp="3cvqtkjht3be6">
                  <span className="font-display text-6xl font-black leading-[0.8]" data-id="element-258" data-mp="3lv44zhphqa1j">
                    {index + 1}
                  </span>
                  <div data-id="element-259" data-mp="3htil3cejgvhu">
                    <p className="text-[11px] font-bold uppercase tracking-[0.16em] opacity-80" data-id="element-260" data-mp="3hqwgnlmy2w3u">
                      {volume.number}
                    </p>
                    <h3 className="mt-1 font-display text-lg font-bold leading-snug" data-id="element-261" data-mp="2p5efsrzvqkfo">
                      {volume.title}
                    </h3>
                  </div>
                </div>
                <div className="space-y-3 px-6 py-6 text-sm leading-relaxed text-ink-soft" data-id="element-262" data-mp="2y3yqb5vadnst">
                  {volume.paragraphs.map((paragraph, pIndex) => <p key={paragraph} className={pIndex === 0 ? 'font-semibold text-ink' : ''} data-id="element-263" data-mp="2adch3b9jpxh8" data-mpi={pIndex}>
                      {paragraph}
                    </p>)}
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-20 rounded-[2rem] bg-ink px-6 py-14 text-white sm:px-12 sm:py-16" data-id="element-264" data-mp="9bd7mvwalwo5">
          <h3 className="text-center font-display text-2xl font-black leading-tight tracking-tight sm:text-4xl" data-id="element-265" data-mp="e9y18ch1hi3m">
            More Than Reading Material.{' '}
            <span className="text-sun" data-id="element-266" data-mp="o0so9j240lq4">A Teaching Toolkit.</span>
          </h3>
          <ul className="mt-12 grid gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-267" data-mp="3mkj4kxl5g8mv">
            {toolkitItems.map((item, index) => {
            const Icon = toolkitIcons[index];
            return <li key={item.title} className="flex gap-4" data-id="element-268" data-mp="bzxs249b62w" data-mpi={index}>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-sun text-ink" data-id="element-269" data-mp="em7a7apjvnr">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-270" data-mp="1brolivpc494r" />
                  </span>
                  <div data-id="element-271" data-mp="1bu0z6wo27xc0">
                    <h4 className="font-display text-base font-bold leading-snug" data-id="element-272" data-mp="1gq9mwygboyus">
                      {item.title}
                    </h4>
                    <p className="mt-1.5 text-sm leading-relaxed text-white/70" data-id="element-273" data-mp="318agv5olklru">
                      {item.text}
                    </p>
                  </div>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}